<template>
  <ImageSelectCropper :id-image="idImage"
                      context="community"
                      :width="396" :height="223"
                      @changeImage="onChangeImage"
                      @removeImage="onRemoveImage"
  />
</template>

<script>
import ImageSelectCropper from '../shared/imageSelectCropper/ImageSelectCropper.vue'

export default {
  name: 'CommunityImageSelect',
  components: { ImageSelectCropper },
  props: {
    idImage: {
      type: String,
      default: ''
    }
  },
  methods: {
    onChangeImage(args) {
      this.$emit('changeImage', args)
    },
    onRemoveImage(args) {
      this.$emit('removeImage', args)
    }
  }
}
</script>
